import { useDispatch } from 'react-redux';
import { AppDispatch } from '../utilities';

export const useAppDispatch: () => AppDispatch = useDispatch;
